import {InlineDataProps, InlineDatumProps} from './types';
import {Datum} from './datum/Datum';
import {useInlineDataState} from './useInlineDataState';

export const InlineDataComponent = (props: InlineDataProps) => {
  const {name} = props;
  const dataProps = useInlineDataState(props);

  const datumComponents = dataProps.map(
    (datumProps: InlineDatumProps, i: number) => {
      const {datum_type: datumType} = datumProps.datum;
      const key = `${i}-${datumType}`;
      return <Datum key={key} {...datumProps} />;
    },
  );

  return (
    <div
      style={{minWidth: 0, width: '100%'}}
      data-testid={`inline-data-${name}`}
    >
      {datumComponents}
    </div>
  );
};
